export default __webpack_public_path__ + "static/media/wallet.05ed7190.png";